import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2022SGM() {
  return <CategoryPage category="anexo30Y31Ano2022SGM" pageTitle="Sistema de Gestión de Medición 2022" />;
}

export default Anexo30Y31Ano2022SGM;
